const ApiError = ({ axiosError }) => {
  const accessDenied = axiosError?.response?.status === 403
  const errorMessage = axiosError?.response?.data?.message || ""

  return errorMessage ? (
    <div className="mt-2 p-4 bg-red-100 rounded-lg">
      <p className="text-center text-sm text-rose-700">
        {accessDenied
          ? "You do not have permission to access this resource or perform this action."
          : errorMessage}
      </p>
    </div>
  ) : null
}

export default ApiError
